import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchSaleDeliveryList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/saleDelivery/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                dispatch('fetchSaleDeliveryList', payload)
            } else {
                commit('setSaleDeliveryList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const sendSaleDeliveryOTP = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/saleDelivery/generateOTP.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setSaleDeliveryOTP', res.data.otp)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchSaleDeliveryData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/saleDelivery/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            dispatch('fetchCustomerMasterData', {id: res.data.response.customer_id})
            commit('setSaleDeliveryData', {response: res.data.response, copy: payload.copy})   
            
            setTimeout(() => {
                if(payload.navigate) {
                    router.push(router.currentRoute.fullPath+'/form/')
                }    
            }, 1000);
            

        } else {
            commit('resetSaleDeliveryData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitSaleDeliveryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleDelivery/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(!payload.production_work_delivery) {
                dispatch('fetchSaleDeliveryData', {id: res.data.id})
            }            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitShipment = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/submitShipment.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {     

        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteSaleDeliveryData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleDelivery/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchSaleDeliveryList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadReadyItemsForDelivery = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleDelivery/loadReadyItemsForDelivery.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setLoadReadyItemsForDelivery', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateSaleDeliveryShipmentDetail = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleDelivery/updateSaleDeliveryShipmentDetail.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/saleDelivery/actions.js